export const userManagement_LABELS = {
  confirmation: "Confirmation",
  disableClinicMessage: "Are you sure to Disable Clinic?",
  activateClinicMessage: "Are you sure to Activate Clinic?",
  userManagement: "User Management",
  addClinic: "Add Clinic",
  firstName: "First Name",
  lastName: "Last Name",
  emailAddress: "Email Address",
  contactNumber: "Contact",
  clinic: "Clinic Name",
  address: "Address",
  actions: "Actions",
  superAdmin: "Super User",
  audit: "Audit",
  logo: "Logo",
  licenceKey: "Licence Key",
  providerName: "Provider Name",
  providerId: "Provider ID",
  role: "Role",
  bpSiteId: "BP Site ID",
  noOfLicenceKeys: "Total Licences",
  noOfUsers: "GPs Assigned",
  status: "Subscription",
  createdDate: "Created Date",
  haloConnection: "Halo Connection",
  itemNumber: "Item Number",
  requestId: "Request ID",
  fromToDate: "From - To Date",
  requestedDate: "Requested Date",
  requestedBy: "Requested By",
  actionStatus: "Status/Action",
};
